
























import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { CalendarFilter } from "@/store/modules/types";

@Component({
  computed: mapState("gaps", ["insurers"])
})
export default class CalendarSearch extends Vue {
  @Model("change") readonly filter!: CalendarFilter;
}
